/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiDeviceFromJSON, StreemApiDeviceToJSON, } from './';
export function StreemApiUpdateDeviceRequestFromJSON(json) {
    return StreemApiUpdateDeviceRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateDeviceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'device': !exists(json, 'device') ? undefined : StreemApiDeviceFromJSON(json['device']),
    };
}
export function StreemApiUpdateDeviceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device': StreemApiDeviceToJSON(value.device),
    };
}
//# sourceMappingURL=StreemApiUpdateDeviceRequest.js.map